import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffDesign = () => import('./staff/design')
const ViewStaffReportLog = () => import('./staff/log')

Vue.use(Router)

const router =
  [
    {
      path: '/st/reports',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: 'ReportsStaffDashboard',
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Reportes',
          }          
        },                
        {
          path: 'design',
          name: 'ReportsStaffDesign',
          component: ViewStaffDesign,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Diseño de reportes',
          }          
        },          
        {
          path: 'log',
          name: 'ReportsStaffReportLog',
          component: ViewStaffReportLog,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Log de impresiones',
          }          
        },                  
      ]
    },
  ]

export default router
